import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const AddGuestModal = ({ propertyId, onClose, onAddGuest }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !startDate || !endDate) {
      alert('Todos los campos son obligatorios');
      return;
    }

    const newGuest = {
      propertyId,
      name,
      email,
      startDate,
      endDate,
    };

    onAddGuest(newGuest);
  };

  return (
    <AnimatePresence>
      <ModalOverlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <ModalContent
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <h2>Añadir Huésped</h2>
          <form onSubmit={handleSubmit}>
            <label>Nombre</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />

            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

            <label>Fecha de Inicio</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />

            <label>Fecha de Fin</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} required />

            <div className="button-group">
              <motion.button
                type="submit"
                className="save-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Añadir
              </motion.button>
              <motion.button
                type="button"
                className="cancel-btn"
                onClick={onClose}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Cancelar
              </motion.button>
            </div>
          </form>
        </ModalContent>
      </ModalOverlay>
    </AnimatePresence>
  );
};

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled(motion.div)`
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;

  h2 {
    margin-bottom: 15px;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  label {
    text-align: left;
    font-weight: bold;
    margin: 10px 0 5px;
  }

  input {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .save-btn {
    background-color: #008080;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .save-btn:hover {
    background-color: #006666;
  }

  .cancel-btn {
    background-color: #d9534f;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .cancel-btn:hover {
    background-color: #b52b27;
  }
`;

export default AddGuestModal;